import React, { useId } from "react";
import {
  TableContainer,
  TableWrapper,
  Table,
  TableBody,
} from "./CustomTableStyles";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import usePagination from "./hooks/usePagination";
import TableHeaders from "./components/TableHeaders";
import TableRows from "./components/TableRows";
import Pagination from "./components/Pagination";

const CustomTable = ({
  columns,
  dataSource,
  pageSize = 10,
  headerColor,
  textHeaderColor,
  paginationColor,
  showPagination = false,
  hideHeader = false,
  cellColor,
  width,
  maxWidth,
  containerWidth,
  containerMaxWidth,
  testid,
}) => {
  const empresa = useEmpresa();
  const id = useId();

  const { currentItems, totalPages, currentPage, handlePageChange } =
    usePagination(dataSource, pageSize);

  const font = empresa?.LETRA_PRINCIPAL;
  const finalCellColor = cellColor || empresa?.COLOR_PRINCIPAL;

  return (
    <TableContainer
      font={font}
      width={containerWidth}
      maxWidth={containerMaxWidth}
      testid={testid}
    >
      <TableWrapper font={font} width={width} maxWidth={maxWidth}>
        <Table font={font}>
          <CheckRender allowed={!hideHeader}>
            <TableHeaders
              columns={columns}
              headerColor={headerColor}
              textHeaderColor={textHeaderColor}
              cellColor={finalCellColor}
              font={font}
              id={id}
            />
          </CheckRender>
          <TableBody>
            <TableRows
              columns={columns}
              currentItems={currentItems}
              font={font}
            />
          </TableBody>
        </Table>
      </TableWrapper>

      <CheckRender allowed={showPagination}>
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          paginationColor={paginationColor}
          font={font}
        />
      </CheckRender>
    </TableContainer>
  );
};

export default CustomTable;
